import { callCrashGameGraphQLQuery } from "../../hooks/crashHooksdummy/axiosClient";


const DEPOSIT_HISTORY_QUERY = `
  query DepositHistory($userAddress: String!) {
    deposits(orderDirection: desc, orderBy: blockTimestamp, where: { sender: $userAddress }) {
      sender
      receiver
      transactionHash
      assets
      blockTimestamp
      shares
      id
      blockNumber
      asset
    }
  }
`;

const WITHDRAWAL_HISTORY_QUERY = `
  query WithdrawalHistory($userAddress: String!) {
    withdraws(orderBy: blockTimestamp, orderDirection: desc, where: { sender: $userAddress }) {
      blockTimestamp
      sender
      transactionHash
      shares
      id
      assets
      blockNumber
      asset
    }
  }
`;

const LIQUIDITY_CLAIM_QUERY = `
  query LiquidityClaim($userAddress: String!) {
    liquidities(where: { user: $userAddress }) {
      asset
      id
      user
      allTimeWithdraws
      allTimeDeposits
    }
  }
`;

const PENDING_WITHDRAWALS_QUERY = `
  query PendingWithdrawals($userAddress: String!) {
    withdrawalReserveds(
      where: { sender: $userAddress }
      orderBy: blockTimestamp
      orderDirection: desc
    ) {
      transactionHash
      shares
      sender
      id
      fees
      blockTimestamp
      blockNumber
      assets
      asset
      activeQueueLength
      receiver
    }
  }
`;

const OPEN_POSITIONS_QUERY = `
  query OpenPositionTerminations($startTimestamp: String!, $endTimestamp: String!) {
    openPositionTerminations(
      where: {
        blockTimestamp_gte: $startTimestamp
        blockTimestamp_lte: $endTimestamp
      }
    ) {
      amount
    }
  }
`;


export const fetchDepositHistory = async (userAddress) => {
    try {
        const data = await callCrashGameGraphQLQuery(DEPOSIT_HISTORY_QUERY, {
            userAddress,
        });
        return data?.deposits || [];
    } catch (error) {
        console.error("Error fetching deposit history:", error);
        return [];
    }
};

export const fetchWithdrawalHistory = async (userAddress) => {
    try {
        const data = await callCrashGameGraphQLQuery(WITHDRAWAL_HISTORY_QUERY, {
            userAddress,
        });
        return data?.withdraws || [];
    } catch (error) {
        console.error("Error fetching withdrawal history:", error);
        return [];
    }
};

export const fetchLiquidityClaim = async (userAddress) => {
    try {
        const data = await callCrashGameGraphQLQuery(LIQUIDITY_CLAIM_QUERY, {
            userAddress,
        });

        const liquidity = data?.liquidities?.[0];
        return {
            allTimeWithdraws: liquidity?.allTimeWithdraws || "0",
            allTimeDeposits: liquidity?.allTimeDeposits || "0",
        };
    } catch (error) {
        console.error("Error fetching liquidity claim:", error);
        return {
            allTimeWithdraws: "0",
            allTimeDeposits: "0",
        };
    }
};

export const fetchPendingWithdrawals = async (userAddress) => {
    try {
        const data = await callCrashGameGraphQLQuery(PENDING_WITHDRAWALS_QUERY, {
            userAddress,
        });
        return data?.withdrawalReserveds || [];
    } catch (error) {
        console.error("Error fetching pending withdrawals:", error);
        return [];
    }
};

export const fetchOpenPositions = async () => {
    try {
        const currentEpoch = Math.floor(Date.now() / 1000);

        const currentDate = new Date(currentEpoch * 1000);
        const startOfDay = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate()
        );

        const startOfDayEpoch = Math.floor(startOfDay.getTime() / 1000);
        const endOfDayEpoch = startOfDayEpoch + 86399;

        const data = await callCrashGameGraphQLQuery(OPEN_POSITIONS_QUERY, {
            startTimestamp: startOfDayEpoch.toString(),
            endTimestamp: endOfDayEpoch.toString(),
        });

        return data?.openPositionTerminations || [];
    } catch (error) {
        console.error("Error fetching open positions:", error);
        return [];
    }
};
